import { useHasPermissions } from '@config/config.hooks';
import { EPermission, ERolePermission } from '@userProfile/permission/permission.constants';
import { routes } from '@routes/routes.models';
import { IReportItemConfig } from './report.models';
import { EReportType } from './report.constants';

export const useReportList = () => {
  const hasMobileUsagePermission = useHasPermissions(
    [EPermission.WEB_MASTER, EPermission.MOBILE_USAGE_VIEWER],
    undefined,
    undefined,
    false,
  );
  const hasChecklistPermission = useHasPermissions(
    [ERolePermission.HEAD_OF_ENGINEERING, ERolePermission.IMS_TEAM_OR_SYSTEM_DEVELOPER],
    undefined,
    undefined,
    false,
  );

  const reportList: IReportItemConfig[] = [];
  if (hasChecklistPermission)
    reportList.push({
      name: 'Checklist Statistics',
      type: EReportType.CHECKLIST_STAT,
      route: routes.report.checklistStat.path,
    });
  if (hasMobileUsagePermission)
    reportList.push({
      name: 'T4 Mobile Usage',
      type: EReportType.T4_MOBILE_USAGE,
      route: routes.report.mobileUsage.path,
    });

  return reportList;
};
